/*
 * Rob Edwards or Christopher Nash for help on migration off ft-user
 * For FtUser questions, post in the #lynx slack channel
 *
 * https://familysearch.splunkcloud.com/en-US/app/fs-turbo/ftuser_shutdown_scoreboard?form.location=production&form.caller_filter=*&form.referer_filter=*
 * https://icseng.atlassian.net/wiki/spaces/Product/pages/133597376/FTUser+Retirement+Migration+Guide+E-28687
 *
 * */

import axios from '@fs/zion-axios'
import { getSession, validUserSessionOrError } from '@fs/zion-session'
import { getCachedUser, setCachedUser } from './cache'
import normalize from './normalize'
import { fetchContact } from './fetchContact'

const hasWindow = typeof window !== 'undefined'

const axiosInstance = axios.create()

let axiosPromise

export default async function fetchUserNoFtUser(requestProxyUser = false) {
  validUserSessionOrError()

  const cachedUser = getCachedUser()
  // Check to make sure we have a window object, and dtrum is on it.
  // We also only want to do send this to dyna if we have a user in cache.
  if (hasWindow && window.dtrum && cachedUser) {
    window.dtrum?.identifyUser(cachedUser?.user?.cisId)
  }
  // This is an alternative way to send the user to dynatrace.
  // We have instead decided for the time being to use the
  // dynatrace API call identifyUser (above).
  // window.FS?.attrs?.cisId = cachedUser?.cisId

  if (cachedUser) {
    if (requestProxyUser && cachedUser.helpee) {
      return cachedUser
    }
    if (!requestProxyUser) {
      return cachedUser
    }
  }

  const url = '/platform/users/current'
  axiosPromise = axiosPromise || axiosInstance.get(url, { fsUserAgentChainSuffix: 'zion-user' })

  const { data } = await axiosPromise
  const user = data.users[0]
  axiosPromise = false
  // ft-user previously returned the birthdate in en-GB format
  // but it was determined that the ISO 8601 format returned from platform is more appropriate
  // See https://icseng.atlassian.net/browse/ORCHSTRTN-110
  user.birthdate = user.birthDate
  user.cpUserId = user.treeUserId

  if (requestProxyUser) {
    const proxyUser = await getProxyUser()

    if (proxyUser) {
      user.proxyContact = {
        id: proxyUser.id, // the cisId of the proxy user (helpee)
        contactName: proxyUser.contactName,
        cpUserId: user.cpUserId,
        personId: user.personId,
      }
    }
  }

  user && setCachedUser(user)

  return normalize(user)
}

async function getProxyUser() {
  const {
    session: { proxyId, proxyType },
  } = await getSession()

  if (proxyId && proxyType === 'HELPER') {
    const { contactName } = await fetchContact({ cisId: proxyId })
    if (contactName) {
      return { id: proxyId, contactName }
    }
  }

  return null
}
